import * as Yup from "yup";

export const instituteValidationSchema = Yup.object({
  name: Yup.string()
    .required("Institute name is required")
    .min(3, "Institute name must be at least 3 characters")
    .max(100, "Institute name must not exceed 100 characters"),

  email: Yup.string()
    .required("Email is required")
    .email("Invalid email format"),

  phoneNumber: Yup.string()
    .required("Invalid Phone Number")
    .matches(/^[0-9]{7,15}$/, "Invalid Phone Number"),

  website: Yup.string()
    .url("Website must be a valid URL")
    .nullable(),

  street: Yup.string()
    .max(200, "Street must not exceed 200 characters")
    .nullable(),

  city: Yup.string()
    .max(100, "City must not exceed 100 characters")
    .nullable(),

  state: Yup.string()
    .max(100, "State must not exceed 100 characters")
    .nullable(),

  country: Yup.string()
    .max(100, "Country must not exceed 100 characters")
    .nullable(),

  pinCode: Yup.string()
    .matches(/^[0-9]{4,10}$/, "Pin code must be between 4 to 10 digits")
    .nullable(),

  latitude: Yup.number()
    .min(-90, "Latitude must be between -90 and 90")
    .max(90, "Latitude must be between -90 and 90")
    .nullable(),

  longitude: Yup.number()
    .min(-180, "Longitude must be between -180 and 180")
    .max(180, "Longitude must be between -180 and 180")
    .nullable(),

  instituteDistanceRadius: Yup.number()
    .min(0, "Radius must be a positive number")
    .nullable(),

  teacherClassDistanceRadius: Yup.number()
    .min(0, "Radius must be a positive number")
    .nullable(),

  attendanceTokenRefreshSeconds: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null || originalValue === undefined
        ? undefined
        : value
    )
    .typeError("Refresh interval must be a whole number of seconds")
    .integer("Refresh interval must be a whole number of seconds")
    .min(15, "Refresh interval must be at least 15 seconds")
    .max(1800, "Refresh interval must not exceed 1800 seconds")
    .notRequired()
    .nullable(),

  profileImage: Yup.mixed()
    .nullable()
    .test(
      "fileSize",
      "File size must be less than 5MB",
      (value) => {
        if (!value) return true;
        // Existing image from server (string URL/path) – skip file size check
        if (typeof value === "string") return true;
        return value.size <= 5 * 1024 * 1024;
      }
    )
    .test(
      "fileType",
      "Only image files are allowed (jpg, jpeg, png, gif)",
      (value) => {
        if (!value) return true;
        // Existing image from server (string URL/path) – skip file type check
        if (typeof value === "string") return true;
        return ["image/jpg", "image/jpeg", "image/png", "image/gif"].includes(
          value.type
        );
      }
    ),
});
